import React from 'react'
import { IconButton } from 'shared/ui'
import { propFunc } from 'util/functions'

const BulkStarIcon = ({
  areAllSelectedStarred,
  count,
  iconSize,
  onStarClick,
}) => {
  return (
    <IconButton
      tooltip={`${
        areAllSelectedStarred ? 'Unstar' : 'Star'
      } all selected items`}
      name={areAllSelectedStarred ? 'star' : 'star-outline'}
      onClick={propFunc(onStarClick, count, areAllSelectedStarred)}
      color="yellow"
      size="small"
      iconSize={iconSize}
      active={areAllSelectedStarred}
    />
  )
}
export default BulkStarIcon
